module.exports = __webpack_public_path__ + "img/select.37e301b6.png";